import { css } from 'styled-components';
import { IS_TENANT, isTenantByName } from 'tenant/utils';
import { breakpoints } from 'utils/style/media';

// icon position for desktop (no collapse icon in menu bar)
const regularBeamerCSS = css`
  .beamer_defaultBeamerSelector {
    box-shadow: none !important;
    bottom: 10px !important;
    left: 10px !important;
    pointer-events: none;
    animation: none !important;
    border-radius: 0 !important;
    background-color: transparent !important;
  }
`;

// icon position for tablet (above collapse icon in menu bar)
const tabletBeamerCSS = css`
  @media (max-width: ${breakpoints.huge}) {
    .beamer_defaultBeamerSelector {
      bottom: 90px !important;
    }
  }
`;

// icon position for mobile (on appBar)
const mobileBeamerCSS = css`
  @media (max-width: ${breakpoints.small}) {
    .beamer_defaultBeamerSelector {
      top: 5px !important;
      right: 78px !important;
      left: auto !important;
    }
  }
`;

const nonTenantStyles = css`
  ${regularBeamerCSS};
  ${tabletBeamerCSS};
  ${mobileBeamerCSS};
`;

const tenantStyles = css`
  .beamer_defaultBeamerSelector {
    display: none !important;
  }
`;

const beamerStyles =
  IS_TENANT || isTenantByName('xpo') ? tenantStyles : nonTenantStyles;

export default beamerStyles;
